// extracted by mini-css-extract-plugin
export var actions = "_gp-g";
export var benefitCard = "_gp-b";
export var benefitIcon = "_gp-d";
export var benefitLabel = "_gp-f";
export var benefits = "_gp-a";
export var benefitsSection = "_gp-8";
export var bodyText = "_gp-7";
export var closeButton = "_gp-2";
export var content = "_gp-3";
export var eyebrow = "_gp-4";
export var heading = "_gp-5";
export var image = "_gp-i";
export var imagePanel = "_gp-h";
export var modal = "_gp-0";
export var offerCard = "_gp-c";
export var offerIcon = "_gp-e";
export var sectionLabel = "_gp-9";
export var shell = "_gp-1";
export var title = "_gp-6";